import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { getPaginationConfig } from '../../../components/pagination';
import { Popover, Table } from 'antd';
@inject('webEDIStore', 'uiState')
@observer
class SearchResult extends Component {
  state={
  }
  componentDidMount() {
  }
  handlePageChange = (page, pageSize) => {
    const { webEDIStore } = this.props;
    webEDIStore.onChangePageNumAction(page, pageSize);
    webEDIStore.onChangeSelectedRowKeys([],[])
  }
  onSelectChange = (selectedRowKeys, selectedRows) => {
    const { webEDIStore } = this.props;
    webEDIStore.onChangeSelectedRowKeys(selectedRowKeys,selectedRows)
  }
  onGetCheckboxProps=(record)=>{
    return {disabled: record.status!=='发送失败'}
  }
  handleExport = (record) => {
    const { uiState } = this.props
    uiState.onChangeFetchingExport(`/china/web/edi/file/download/${record.orderFileId}`, null,`${record.orderFileName}`)
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
    const { webEDIStore } = this.props
    const { pageNo, pageSize, itemCount, webEDIList,selectedRowKeys } = webEDIStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange);
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      getCheckboxProps: this.onGetCheckboxProps,
    };
      return (
        <>
          <Table className='searchResult' dataSource={toJS(webEDIList)} rowSelection={rowSelection} pagination={pagination} rowClassName={this.getRowClassName} rowKey="sendId" scroll={{ x: 'max-content',scrollToFirstRowOnChange:true}} bordered>
            <Table.Column title='Sender Mail' dataIndex="senderMail" key="senderMail"  />
            <Table.Column title='Ship To' dataIndex="shipTo" key="shipTo"  />
            <Table.Column title='Customer PO NO' dataIndex="customerPoNo" key="customerPoNo"  />
            <Table.Column title='Status' dataIndex="status" key="status"  />
            <Table.Column title='Message' dataIndex="message" key="message" render={(text,record) => (
              <Popover content={(JSON.parse(text)?.map(item =><p style={{marginBottom: 0}}>{item}</p>))} >
                {record.status==='发送失败'?JSON.parse(text)?.join(", "):null}
              </Popover>
            )}/>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Table.Column title='Original Order File' dataIndex="orderFileName" key="orderFileName" render={(text, record, index) => <a onClick={() => this.handleExport(record)}>{text}</a>}/>
            <Table.Column title='Received Date' dataIndex="receivedDate" key="receivedDate"  />
            <Table.Column title='Send Date' dataIndex="sendDate" key="sendDate"  />
            <Table.Column title='Template Type' dataIndex="templateType" key="templateType"  />
            <Table.Column title='Message ID' dataIndex="messageId" key="messageId"  />
          </Table>
        </>
      );
  }
}

export default SearchResult;
